import React, {useEffect, useState} from 'react'

import "./buttons.scss"
export default function BigButtonPopup(props) {
    const {title, icon, page, background} = props
    const [opacity, setOpacity] = useState(0)
    useEffect(() => {
        setTimeout(() => {
            setOpacity(1)
        }, 50)
    }, [])
    return (
        <div className={`bigButton ${ background }`}>
            <div className='btnContainer'>
                <div className='btnTitle h100 flex center'>
                    <h3>
                        {title}
                    </h3> 
                </div>
                <img className='btnImg' src={ "/" +icon} alt={icon}  style={{opacity : opacity}} />
                <img className='finger' src="/finger-white.svg" alt="" />
            </div>
        </div>
    )
}
